module.exports = __webpack_public_path__ + "static/media/images-count.11ea6e4d.svg";